
webpack.register(
    'modules/the-course/quotes-carousel/quotes-carousel',
    function() {
        return import('modules/the-course/quotes-carousel/quotes-carousel');
    },
    true
);